import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './Products.css';

const Products = () => {
  const [searchParams] = useSearchParams();
  const categoryParam = searchParams.get('category');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 产品分类
  const categories = [
    {
      id: 'support',
      name: '液压支架',
      products: []
    },
    {
      id: 'cylinder',
      name: '液压油缸',
      products: []
    },
    {
      id: 'hose',
      name: '高压胶管',
      products: []
    }
  ];

  // 液压支架产品数据
  const supportProducts = [
    {
      id: 'support-1',
      name: '掩护式液压支架',
      image: '/images/hs-1.jpg',
      extraImages: [
        '/images/hs-1-1.jpg'
      ],
      extraImageLayout: 'large',
      description: '采用整体顶梁与坚固掩护梁结构，能有效支撑和管控采煤工作面顶板，为设备与人员提供安全作业空间；其稳定的四连杆机构抗扭、抗偏载能力强，适用于各种煤层及复杂地质条件下的综采工作面。',
      specs: '以下型号或相似型号均可生产，接受客户定制或者委托设计制造：ZY2000/07/14，ZY3000/07/14，ZY4000/10/22，ZY5000/16/35，ZY5800/17/38，ZY6200/20/42，ZY7400/18/40，ZY8000/22/45，ZY8640/25.5/55，ZY9000/23/48，ZY10000/25/50，ZY13000/25/50。'
    },
    {
      id: 'support-2',
      name: '支撑掩护式液压支架',
      image: '/images/hs-2.jpg',
      extraImages: [
        '/images/hs-2-1.jpg'
      ],
      extraImageLayout: 'large',
      description: '四柱支撑掩护式液压支架兼顾了支撑式液压支架的高强度和掩护式液压支架的护顶防矸功能。支架的支撑力大，切顶能力强。底板比压分布均匀，对底板比压小。整体结构刚性强，抗倾倒、抗滑移性能好',
      specs: '以下型号或相似型号均可生产，接受客户定制或者委托设计制造：ZZ3000/07/14，ZZ3600/08/16，ZZ4000/15/28，ZZ4800/15/32，ZZ5500/18/40，ZZ6400/22/45，ZZ7600/18/38，ZZ8400/21/42，ZZ10000/18/35，ZZ13000/20/40。'
    },
    {
      id: 'support-3',
      name: '放顶煤液压支架',
      image: '/images/hs-3.jpg',
      extraImages: [
        '/images/hs-3-1.jpg'
      ],
      extraImageLayout: 'large',
      description: '专为厚煤层放顶煤开采设计，配备有尾梁与插板可控制顶煤排放和破碎煤块，实现采放同步作业，大幅提升资源开采回收效率；其重心低、抗扭、抗偏载能力强，稳定性好，保障了放煤过程的安全与顺畅。',
      specs: '以下型号或相似型号均可生产，接受客户定制或者委托设计制造：ZF3000/16/25，ZF3200/15/23，ZF3600/16/28，ZF4000/16/30，ZF5400/17/32，ZF6000/18/35，ZF6800/17/33，ZF7200/17/32，ZF8000/20/38，ZF9600/20/39，ZF10000/20/38，ZF13000/20/38。'
    }
  ];

  // 液压油缸产品数据
  const cylinderProducts = [
    {
      id: 'cylinder-1',
      name: '千斤顶',
      image: '/images/cylinder-1.jpg',
      extraImages: [
        '/images/cylinder-1-1.jpg',
        '/images/cylinder-1-2.jpg',
        '/images/cylinder-1-3.jpg',
        '/images/cylinder-1-4.jpg',
        '/images/cylinder-1-5.jpg',
        '/images/cylinder-1-6.jpg'
      ],
      description: '作为液压支架的动力执行元件，涵盖推移、侧推、护帮等多种类型，推力强劲、动作灵敏；优质密封件与精密缸体确保长期往复运动无泄漏，适应井下恶劣工况。',
      specs: '规格从φ30~φ500mm，长度从50-5000mm，且全部通过北京煤科院试验取得国家安全标志证书。'
    },
    {
      id: 'cylinder-2',
      name: '单伸缩立柱',
      image: '/images/cylinder-2.jpg',
      extraImages: [
        '/images/cylinder-2-1.jpg',
        '/images/cylinder-2-2.jpg',
        '/images/cylinder-2-3.jpg',
        '/images/cylinder-2-4.jpg',
        '/images/cylinder-2-5.jpg',
        '/images/cylinder-2-6.jpg',
        '/images/cylinder-2-7.jpg'
      ],
      description: '结构简单、承载能力大，通过单级伸缩快速实现支架支撑高度调节；缸体采用高强度合金钢制造，表面镀覆耐腐蚀层，保障在高压下的稳定支撑性能。',
      specs: '规格从φ100~φ500mm，长度从100-5000mm，且全部通过北京煤科院试验取得国家安全标志证书。'
    },
    {
      id: 'cylinder-3',
      name: '双伸缩立柱',
      image: '/images/cylinder-3.jpg',
      extraImages: [
        '/images/cylinder-3-1.jpg',
        '/images/cylinder-3-2.jpg',
        '/images/cylinder-3-3.jpg',
        '/images/cylinder-3-4.jpg',
        '/images/cylinder-3-5.jpg',
        '/images/cylinder-3-6.jpg'
      ],
      description: '具备两级伸缩功能，调高范围更广，能适应煤层厚度变化剧烈的复杂工作面；内置精确导向装置与双级密封，确保升降平稳、支撑可靠，满足高支护要求。',
      specs: '规格从φ110~φ500mm，长度从150-5000mm，且全部通过北京煤科院试验取得国家安全标志证书。'
    }
  ];

  // 高压胶管产品数据
  const hoseProducts = [
    {
      id: 'hose-1',
      name: '高压钢丝编织胶管',
      image: '/images/hose-1.jpg',
      description: '由内胶层、一层或多层钢丝编织增强层及外胶层构成，耐高压、柔韧性好；适用于煤矿液压系统输送乳化液、液压油等介质，抗脉冲性能优越，连接便捷。',
      specs: '以下规格型号均可生产：2-6-60MPa，2-8-40MPa，2-10-40MPa，2-13-32MPa，2-16-34MPa，2-19-34MPa，2-25-21MPa，2-32-16MPa，2-38-11MPa，2-51-11MPa，3-10-53MPa，3-13-38MPa，3-16-34MPa，3-19-34MPa，3-25-21MPa，3-32-16MPa，3-38-11MPa，3-51-11MPa，且全部通过北京煤科院试验取得国家安全标志证书。'
    },
    {
      id: 'hose-2',
      name: '高压钢丝缠绕胶管',
      image: '/images/hose-2.jpg',
      description: '增强层采用高强度钢丝缠绕结构，比编织胶管具有更高承压能力与抗冲击性能；专门用于超高压工况（如支架液压系统主管路），耐磨损、耐屈挠，使用寿命长。',
      specs: '以下规格型号均可生产：4-10-70MPa，4-13-60MPa，4-16-55MPa，4-19-46MPa，4-25-35(38)MPa，4-32-32(35)MPa，4-38-25(40)MPa，4-51-20(35)MPa，6-25-46MPa，6-32-40MPa，6-38-35MPa，6-51-30MPa，且全部通过北京煤科院试验取得国家安全标志证书。'
    },
    {
      id: 'hose-3',
      name: '高压胶管总成',
      image: '/images/hose-3.jpg',
      description: '将高压胶管与各类金属接头经扣压或剥胶工艺组装而成，规格齐全、密封可靠；出厂前均经过严格压力测试，可直接安装使用，大幅减少现场装配时间与泄漏风险。',
      specs: '高压胶管总成的胶管规格包含了编织胶管和缠绕胶管的所有规格，扣压接头包含了KJ快捷接头，DN快捷接头，以及H型，A型等特殊接头型号。'
    }
  ];

  const initProducts = () => {
    categories.forEach(category => {
      if (category.id === 'support') {
        category.products = supportProducts;
      } else if (category.id === 'cylinder') {
        category.products = cylinderProducts;
      } else if (category.id === 'hose') {
        category.products = hoseProducts;
      }
    });
  };
  initProducts();

  // 根据 URL 参数获取默认分类
  const getDefaultCategory = () => {
    if (categoryParam) {
      const found = categories.find(c => c.id === categoryParam);
      return found || categories[0];
    }
    return categories[0];
  };

  const [activeCategory, setActiveCategory] = useState(getDefaultCategory);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    setSelectedProduct(null);
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  const handleBackToList = () => {
    setSelectedProduct(null);
  };

  return (
    <>
      {/* 产品展示 */}
      <section className="products-showcase section">
        <div className="container">
          <div className="products-container">
            {/* 左侧分类导航 */}
            <div className="products-sidebar">
              <h3 className="sidebar-title">产品分类</h3>
              <ul className="category-list">
                {categories.map(category => (
                  <li
                    key={category.id}
                    className={`category-item ${activeCategory.id === category.id ? 'active' : ''}`}
                    onClick={() => handleCategoryClick(category)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        handleCategoryClick(category);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    <span className="category-name">{category.name}</span>
                    <span className="category-count">{category.products.length}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* 右侧内容区域 */}
            <div className="products-content">
              {selectedProduct ? (
                /* 产品详情 */
                <div className="product-detail">
                  <button type="button" className="back-button" onClick={handleBackToList}>
                    ← 返回产品列表
                  </button>
                  <div className="product-detail-content">
                    <div className="product-detail-image">
                      <img src={selectedProduct.image} alt={selectedProduct.name} />
                    </div>
                    <div className="product-detail-info">
                      <h2 className="product-detail-title">{selectedProduct.name}</h2>
                      <div className="product-detail-desc">
                        <h3>产品描述</h3>
                        <p>{selectedProduct.description}</p>
                        <h3>产品规格</h3>
                        <p>{selectedProduct.specs}</p>
                      </div>
                    </div>
                  </div>
                  {selectedProduct.extraImages && selectedProduct.extraImages.length > 0 && (
                    <div className="product-detail-extra">
                      <h3>产品图片</h3>
                      {selectedProduct.extraImageLayout === 'large' ? (
                        <div className="product-detail-extra-large">
                          {selectedProduct.extraImages.map((img) => (
                            <div key={img} className="product-detail-extra-large-item">
                              <img src={img} alt={selectedProduct.name} />
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="product-detail-extra-grid">
                          {selectedProduct.extraImages.map((img) => (
                            <img key={img} src={img} alt={selectedProduct.name} />
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                /* 产品列表 */
                <>
                  <div className="category-header">
                    <h3 className="category-title">
                      {activeCategory.name}
                    </h3>
                  </div>

                  <div className="products-grid">
                    {activeCategory.products.map(product => (
                      <button
                        type="button"
                        key={product.id}
                        className="product-item"
                        onClick={() => handleProductClick(product)}
                      >
                        <div className="product-image-wrapper">
                          <img src={product.image} alt={product.name} />
                        </div>
                        <div className="product-name">{product.name}</div>
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Products;
